export class ThemeObserver {
  constructor() {
    this.sidebar = document.querySelector('.sidebar');
    this.scrollToTop = document.querySelector('.scroll-to-top');

    if (this.sidebar) {
      this.initSidebar();
    }

    if (this.scrollToTop) {
      this.initScrollToTop();
    }
  }

  initSidebar() {
    const collapseElements = [].slice.call(this.sidebar.querySelectorAll('.collapse'));
    const collapseList = collapseElements.map((el) => {
      return new bootstrap.Collapse(el, { toggle: false });
    });

    const toggles = document.querySelectorAll('#sidebarToggle, #sidebarToggleTop');
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        document.body.classList.toggle('sidebar-toggled');
        this.sidebar.classList.toggle('toggled');

        if (this.sidebar.classList.contains('toggled')) {
          collapseList.forEach((bsCollapse) => bsCollapse.hide());
        }
      });
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < 768) {
        collapseList.forEach((bsCollapse) => bsCollapse.hide());
      }
    });
  }

  initScrollToTop() {
    window.addEventListener('scroll', () => {
      this.scrollToTop.style.display = window.pageYOffset > 100 ? 'block' : 'none';
    });
  }
}
